export default function DeleteRiskTypeConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  riskDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmDelete = _handleConfirmDelete;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return riskDataService.deleteRiskType(vm.riskType.customerRiskTypeId).then((response) => {
      if (response.status === 200) {
        alerts.success(`The Risk Type "${vm.riskType.name}" was successfully deleted.`);
        $rootScope.$broadcast('pra_risk-type-deleted', { riskType: vm.riskType, assetType: vm.assetType });
        $rootScope.$broadcast('refreshAssetTypes');
        $rootScope.$broadcast('refreshRiskTypes');
        $rootScope.$broadcast('refreshAssetType', { assetType: vm.assetType });
        $rootScope.$broadcast('refreshAssets', { assetType: vm.assetType });
        loaderService.showViewLoader = false;
        _closeDialog();
      } else {
        alerts.error('An error occurred while deleting the Risk Type.');
        loaderService.showViewLoader = false;
      }
    });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.riskAdmin.deleteRiskTypeConfirmDialog);
  }
}

DeleteRiskTypeConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'riskDataService',
  'loaderService',
  'ssDialogService'
];
